{
  "diagnostics.fatal.title": "Something went wrong.",
  "diagnostics.fatal.message": "An unexpected error occurred. Reloading the page usually fixes this.",
  "diagnostics.reload": "Reload",
  "diagnostics.translationLoadError": "Translations could not be loaded. English is used instead. Details: {detail}",
  "diagnostics.bootstrap.title": "The application could not start.",
  "diagnostics.bootstrap.unknownError": "Unknown startup error.",
  "testing.workspace.title": "Angular 22 Feature Module (Port 3002)",
  "testing.workspace.userLabel": "User data from Shell:",
  "testing.workspace.telemetry": "📡 Intercepted Sibling Telemetry (React MFE -> Angular MFE):",
  "testing.workspace.waiting": "Waiting for selection inside React MFE...",
  "testing.workspace.broadcast": "✍️ Broadcast Live Message to React MFE:",
  "testing.workspace.broadcastPlaceholder": "Type something to send to React...",
  "testing.workspace.sendAction": "Send Action to Shell",
  "testing.workspace.optionalCapability": "Optional Angular capability",
  "testing.workspace.recommendations": "Optional recommendations",
  "testing.workspace.available": "Recommended profile actions are available.",
  "testing.workspace.simulateOptionalFailure": "Simulate optional data error",
  "testing.workspace.loading": "Loading recommendations…",
  "testing.workspace.unavailable": "Recommendations are temporarily unavailable.",
  "testing.workspace.continue": "You can continue using the Angular workspace.",
  "testing.workspace.retry": "Retry recommendations",
  "testing.workspace.faultControlsLabel": "Angular MFE error-handling demonstration controls",
  "testing.workspace.faultControls": "PoC fault controls",
  "testing.workspace.faultDescription": "Development-only controls for Shell-handled Angular failures.",
  "testing.workspace.simulatePanelFailure": "Simulate MFE panel failure",
  "testing.workspace.simulateRenderFailure": "Simulate unexpected render crash",
  "testing.workspace.simulateCoreFailure": "Simulate critical Shell-handled error",
  "testing.hello.samplePrice": "Sample price: {price}",
  "testing.store.examples": "Internationalization examples",
  "testing.store.addItem": "Add example item",
  "testing.store.toggleStatus": "Toggle example status",
  "testing.inputs.title": "Angular input/output communication examples",
  "testing.inputs.documentation": "See {path} for the full convention this page demonstrates.",
  "testing.inputs.patternA": "Pattern A — simple direct input",
  "testing.inputs.patternB": "Pattern B — multiple simple inputs (including falsy values)",
  "testing.inputs.patternC": "Pattern C — input with computed display state",
  "testing.inputs.patternDE": "Pattern D/E — feature-scoped state service, two isolated instances",
  "testing.inputs.patternF": "Pattern F — optional props-object input",
  "testing.inputs.output": "Output — output() event",
  "testing.inputs.changeWord": "Change word",
  "testing.inputs.toggleEnabled": "Toggle enabled",
  "testing.inputs.toggleUser": "Toggle user (present / absent)",
  "testing.inputs.lastSelected": "Last selected: \"{value}\"",
  "testing.inputs.word": "input-test word is {word}",
  "testing.inputs.summary": "Pattern B — multiple simple inputs: title = \"{title}\", count = {count, number}, enabled = {enabled}",
  "testing.inputs.emitSelected": "Emit selected event",
  "testing.inputs.noUser": "No user",
  "testing.inputs.computed": "Pattern C — input with computed state: displayName = \"{name}\"",
  "testing.inputs.featureRoot": "Pattern D/E — feature root wrote its boundary input into TestingFeatureState:",
  "testing.inputs.featureChild": "Descendant reading shared feature state: value = \"{value}\", displayValue = \"{displayValue}\"",
  "testing.inputs.noProps": "(no props)",
  "testing.inputs.card": "Pattern F — props object: label = \"{label}\", role = \"{role}\"",
  "testing.locations.loading": "Loading storage locations...",
  "testing.locations.loadError": "Failed to load storage locations: {detail}",
  "testing.locations.available": "Available storage locations",
  "testing.locations.empty": "No storage locations found.",
  "testing.locations.edit": "Edit storage location",
  "testing.locations.selectedId": "Selected ID:",
  "testing.locations.name": "Name",
  "testing.locations.invalidName": "Name is required and must contain at most 50 characters.",
  "testing.locations.parentId": "Parent ID",
  "testing.locations.type": "Type",
  "testing.locations.invalidType": "Type is required.",
  "testing.locations.costCentreId": "Cost centre ID",
  "testing.locations.properties": "Storage properties",
  "testing.locations.save": "Save changes",
  "testing.locations.saved": "Storage location updated successfully.",
  "testing.locations.updateError": "Failed to update the storage location.",
  "structure.types.building": "Building",
  "structure.types.floor": "Floor",
  "structure.types.room": "Room",
  "structure.types.cabinet": "Cabinet",
  "structure.types.shelf": "Level",
  "structure.types.box": "Box",
  "structure.referenceTree": "Current location structure (read-only)",
  "structure.buildings": "Buildings",
  "structure.floors": "Floors",
  "structure.addType": "Add {type}",
  "structure.actionsFor": "Actions for {name}",
  "structure.locationActions": "Location actions",
  "structure.renameLocation": "Rename {name}",
  "structure.rename": "Rename",
  "structure.duplicate": "Duplicate",
  "structure.rename.required": "Enter a location name.",
  "structure.rename.tooLong": "Use at most 50 characters.",
  "structure.refresh": "Refresh structure",
  "structure.retryRefresh": "Retry refresh",
  "structure.done": "Done",
  "structure.deleteTitle": "Delete location?",
  "structure.deletePrompt": "Are you sure you want to delete this location? This action cannot be undone.",
  "structure.checkingOutcome": "Checking write outcome…",
  "structure.updating": "Updating structure…",
  "structure.deleting": "Deleting location…",
  "structure.outcomeUnknown": "The write outcome is still unknown.",
  "structure.refreshError": "The structure could not be refreshed. Your last loaded structure is still shown. Retry before making more changes.",
  "structure.defaultNameError": "A default name could not be created within the 50-character limit.",
  "structure.duplicateUnavailable": "Duplication is unavailable for {id}: an atomic subtree duplicate endpoint is required.",
  "structure.responseLost": "The response was lost.",
  "structure.uncertainWrite": "{detail} The write may have completed. Checking the latest structure before allowing another write.",
  "structure.reconciliation.createNotObserved": "The created location was not found in the latest structure. Creation is not confirmed. Check the structure before trying again; a delayed write may still appear.",
  "structure.reconciliation.deleteNotObserved": "The location is still present in the latest structure. Deletion is not confirmed. Try again after checking the structure, or cancel.",
  "structure.reconciliation.renameMissing": "The location no longer exists. The rename was not confirmed. Cancel this draft and check the structure.",
  "structure.reconciliation.renameNotObserved": "The latest structure still has the original name. The rename was not confirmed. Your draft is retained; check before trying again.",
  "structure.reconciliation.renameChanged": "The location has a different name in the latest structure. Another change may have occurred. Review it before retrying your draft.",
  "structure.reconciliation.moveMissing": "The location no longer exists. The move was not confirmed. Cancel this draft and check the structure.",
  "structure.reconciliation.moveNotObserved": "The latest structure still has the original parent. The move was not confirmed. Check the structure before trying again.",
  "structure.reconciliation.moveChanged": "The location has a different parent in the latest structure. Another change may have occurred. Review it before retrying.",
  "structure.deleteReasons.assignments": "This location has assigned items and cannot be deleted. Remove the assignments first.",
  "structure.deleteReasons.stock": "This location contains stock and cannot be deleted. Remove the stock first.",
  "structure.deleteReasons.sublocations": "This location has sublocations. Remove the sublocations first.",
  "structure.stockHint": "Hover or focus to load stock count.",
  "structure.stockError": "Stock count could not be loaded. Hover or focus again to retry.",
  "structure.stockLoading": "Loading stock count…",
  "structure.stockCount": "{count, plural, one {# stored item code} other {# stored item codes}}",
  "structure.stockFor": "Stored item codes for {name}",
  "structure.errors.create.forbidden": "The location could not be created. You do not have permission to create locations.",
  "structure.errors.create.authentication": "The location could not be created. Authentication is required.",
  "structure.errors.create.validation": "The location could not be created. Check the location details and try again.",
  "structure.errors.create.conflict": "The location could not be created. The structure may have changed. Try again after checking the latest structure.",
  "structure.errors.create.missing": "The location could not be created. The location or its parent no longer exists.",
  "structure.errors.create.connection": "The location could not be created. The connection was lost.",
  "structure.errors.create.server": "The location could not be created. The server could not complete the request.",
  "structure.errors.create.unknown": "The location could not be created. Try again or cancel.",
  "structure.errors.rename.forbidden": "The location could not be renamed. You do not have permission to rename locations.",
  "structure.errors.rename.authentication": "The location could not be renamed. Authentication is required.",
  "structure.errors.rename.validation": "The location could not be renamed. Check the location details and try again.",
  "structure.errors.rename.conflict": "The location could not be renamed. The structure may have changed. Try again after checking the latest structure.",
  "structure.errors.rename.missing": "The location could not be renamed. The location or its parent no longer exists.",
  "structure.errors.rename.connection": "The location could not be renamed. The connection was lost.",
  "structure.errors.rename.server": "The location could not be renamed. The server could not complete the request.",
  "structure.errors.rename.unknown": "The location could not be renamed. Try again or cancel.",
  "structure.errors.move.forbidden": "The location could not be moved. You do not have permission to move locations.",
  "structure.errors.move.authentication": "The location could not be moved. Authentication is required.",
  "structure.errors.move.validation": "The location could not be moved. Check the location details and try again.",
  "structure.errors.move.conflict": "The location could not be moved. The structure may have changed. Try again after checking the latest structure.",
  "structure.errors.move.missing": "The location could not be moved. The location or its parent no longer exists.",
  "structure.errors.move.connection": "The location could not be moved. The connection was lost.",
  "structure.errors.move.server": "The location could not be moved. The server could not complete the request.",
  "structure.errors.move.unknown": "The location could not be moved. Try again or cancel.",
  "structure.errors.delete.forbidden": "The location could not be deleted. You do not have permission to delete locations.",
  "structure.errors.delete.authentication": "The location could not be deleted. Authentication is required.",
  "structure.errors.delete.validation": "The location could not be deleted. Check the location details and try again.",
  "structure.errors.delete.conflict": "The location could not be deleted. The structure may have changed. Try again after checking the latest structure.",
  "structure.errors.delete.missing": "The location could not be deleted. The location or its parent no longer exists.",
  "structure.errors.delete.connection": "The location could not be deleted. The connection was lost.",
  "structure.errors.delete.server": "The location could not be deleted. The server could not complete the request.",
  "structure.errors.delete.unknown": "The location could not be deleted. Try again or cancel.",
  "structure.errors.setup.forbidden": "The location could not be set up. You do not have permission to set up locations.",
  "structure.errors.setup.authentication": "The location could not be set up. Authentication is required.",
  "structure.errors.setup.validation": "The location could not be set up. Check the location details and try again.",
  "structure.errors.setup.conflict": "The location could not be set up. The structure may have changed. Try again after checking the latest structure.",
  "structure.errors.setup.missing": "The location could not be set up. The location or its parent no longer exists.",
  "structure.errors.setup.connection": "The location could not be set up. The connection was lost.",
  "structure.errors.setup.server": "The location could not be set up. The server could not complete the request.",
  "structure.errors.setup.unknown": "The location could not be set up. Try again or cancel.",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.close": "Close",
  "common.none": "None",
  "common.saving": "Saving…",
  "details.close": "Close details panel",
  "details.expand": "Expand details panel",
  "details.collapse": "Collapse details panel",
  "details.selectItem": "Select an item to see its details.",
  "details.general": "General",
  "stock.currentStock": "Current stock",
  "stock.recommendedStock": "Recommended stock",
  "stock.reorderLimit": "Reorder limit",
  "stock.minimumStock": "Min. stock",
  "details.itemTracking": "Item tracking",
  "details.internalReference": "Internal reference",
  "details.alternativeItems": "Alternative items",
  "details.images": "Images",
  "details.gtin": "GTIN",
  "details.serialNumber": "SN no.",
  "details.errors.assignment": "Assignment could not be loaded.",
  "details.errors.material": "Material could not be loaded.",
  "details.errors.costCentres": "Cost centres could not be loaded.",
  "details.errors.manufacturer": "Manufacturer could not be loaded.",
  "details.errors.brand": "Brand could not be loaded.",
  "details.errors.stock": "Stock could not be loaded.",
  "details.errors.alternativeMaterial": "Alternative material could not be loaded.",
  "assignment.edit": "Edit assignment",
  "assignment.editForm": "Edit item assignment",
  "assignment.confirmDelete": "Delete this item assignment?",
  "assignment.saving": "Saving assignment…",
  "assignment.deleting": "Deleting assignment…",
  "assignment.saveError": "The assignment could not be saved.",
  "assignment.saveErrorDetail": "The assignment could not be saved. {detail}",
  "assignment.deleteError": "The assignment could not be deleted.",
  "assignment.deleteErrorDetail": "The assignment could not be deleted. {detail}",
  "assignment.noAssignment": "This stock position has no assignment to delete.",
  "assignment.requestFailed": "The request failed.",
  "assignment.batchFailure": "{assigned, plural, one {# item assigned.} other {# items assigned.}} {failed, plural, one {# item failed; retry the remaining items.} other {# items failed; retry the remaining items.}} {detail}",
  "assignment.serialNumber": "Serial no.",
  "assignment.lotNumber": "LOT no.",
  "assignment.expiryDate": "Expiry date",
  "assignment.stockThresholds": "Stock thresholds",
  "assignment.options": "Assignment options",
  "assignment.trackingOptions": "Tracking options",
  "assignment.consignation": "Consignation",
  "assignment.storageLocation": "Storage location",
  "assignment.settings": "Assignment settings",
  "assignment.items": "Items",
  "assignment.batchHint": "Select multiple items to use batch assignment.",
  "assignment.searchItems": "Search items",
  "assignment.matchingPanel": "Matching items panel",
  "assignment.searchHint": "Start typing to find the item you are looking for…",
  "assignment.searchError": "Items could not be loaded. Try searching again.",
  "assignment.noMatches": "No matching items found.",
  "assignment.matchingItems": "Matching items",
  "assignment.selectedItems": "Selected items",
  "assignment.noneSelected": "No item selected.",
  "assignment.addItem": "Add {code}, {description}",
  "assignment.removeItem": "Remove {code}",
  "assignment.validation.nonNegative": "Enter a valid non-negative stock value.",
  "assignment.validation.finite": "Enter a valid stock value.",
  "assignment.validation.recommendedRequired": "Recommended stock is required.",
  "assignment.validation.reorderRequired": "Reorder limit is required.",
  "assignment.validation.recommendedOrder": "Recommended stock must be greater than reorder limit.",
  "assignment.validation.reorderMinimumOrder": "Reorder limit must be greater than minimum stock.",
  "assignment.validation.reorderRecommendedOrder": "Reorder limit must be less than recommended stock.",
  "storageLocations.loadError": "Storage locations could not be loaded.",
  "storageLocations.retry": "Retry loading locations",
  "storageLocations.empty": "No storage locations available.",
  "storageLocations.inventory": "Location inventory",
  "storageLocations.assignItem": "Assign item",
  "storageLocations.expandNavigation": "Expand location navigation",
  "storageLocations.collapseNavigation": "Collapse location navigation",
  "stockPositions.loadError": "Stock positions could not be loaded.",
  "stockPositions.empty": "No stock positions found.",
  "stockPositions.resultLimit": "The result limit has been reached. Refine your search to see more stock positions.",
  "stockPositions.confirmDelete": "Delete row for \"{location}\" and \"{materialCode}\"?",
  "stockPositions.columns.itemCode": "Item code",
  "stockPositions.columns.description": "Description",
  "stockPositions.columns.stock": "Stock",
  "stockPositions.columns.location": "Location",
  "domain.costCenter": "Cost center",
  "storageProperties.none": "None",
  "storageProperties.noStorage": "No storage",
  "grid.all": "All",
  "grid.noneSelected": "None selected",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "grid.rowActions": "Row actions",
  "grid.toggleColumns": "Show or hide columns",
  "grid.visibleColumns": "Visible columns",
  "grid.reset": "Reset",
  "common.search": "Search",
  "grid.clearSearch": "Clear search",
  "grid.rowCount": "{count, plural, one {# item} other {# items}}",
  "grid.filteredRowCount": "{count, plural, one {{displayed, number} of # item} other {{displayed, number} of # items}}",
  "grid.ag.noRowsToShow": "No Rows To Show",
  "grid.ag.noMatchingRows": "No Matching Rows",
  "grid.ag.loadingOoo": "Loading...",
  "grid.ag.thousandSeparator": ",",
  "grid.ag.decimalSeparator": ".",
  "grid.ag.ariaSortableColumn": "Press ENTER to sort",
  "grid.ag.ariaMenuColumn": "Press ALT DOWN to open column menu",
  "grid.ag.ariaFilterColumn": "Press CTRL ENTER to open filter",
  "grid.ag.ariaColumnFiltered": "Column Filtered",
  "grid.ag.ariaRowSelect": "Press SPACE to select this row",
  "grid.ag.ariaRowDeselect": "Press SPACE to deselect this row",
  "grid.ag.ariaRowToggleSelection": "Press Space to toggle row selection",
  "grid.ag.ariaRowSelectionDisabled": "Row Selection is disabled for this row",
  "grid.ag.ariaRowSelectAll": "Press Space to toggle all rows selection",
  "grid.ag.ariaHeaderSelection": "Column with Header Selection",
  "grid.ag.ariaChecked": "checked",
  "grid.ag.ariaUnchecked": "unchecked",
  "grid.ag.ariaIndeterminate": "indeterminate",
  "grid.ag.ariaLabelSelectField": "Select Field",
  "grid.ag.ariaLabelInputClear": "Clear",
  "grid.ag.ariaLabelColumnFilter": "Column Filter",
  "grid.ag.ariaFilterMenuOpen": "Open Filter Menu",
  "grid.ag.ariaFilterInput": "Filter Input",
  "grid.ag.ariaFilterValue": "Filter Value",
  "grid.ag.ariaFilterFromValue": "Filter from value",
  "grid.ag.ariaFilterToValue": "Filter to Value",
  "grid.ag.ariaFilteringOperator": "Filtering operator",
  "grid.ag.filterOoo": "Filter...",
  "grid.ag.equals": "Equals",
  "grid.ag.notEqual": "Does not equal",
  "grid.ag.contains": "Contains",
  "grid.ag.notContains": "Does not contain",
  "grid.ag.startsWith": "Begins with",
  "grid.ag.endsWith": "Ends with",
  "grid.ag.blank": "Blank",
  "grid.ag.notBlank": "Not blank",
  "grid.ag.andCondition": "AND",
  "grid.ag.orCondition": "OR",
  "grid.ag.applyFilter": "Apply",
  "grid.ag.resetFilter": "Reset",
  "grid.ag.clearFilter": "Clear",
  "grid.ag.cancelFilter": "Cancel",
  "grid.ag.pageSizeSelectorLabel": "Page Size:",
  "grid.ag.ariaPageSizeSelectorLabel": "Page Size",
  "grid.ag.page": "Page",
  "grid.ag.number": "number",
  "grid.ag.of": "of",
  "grid.ag.to": "to",
  "grid.ag.more": "more",
  "grid.ag.firstPage": "First Page",
  "grid.ag.previousPage": "Previous Page",
  "grid.ag.nextPage": "Next Page",
  "grid.ag.lastPage": "Last Page",
  "grid.ag.pageLastRowUnknown": "?",
  "app.title": "Inventory Management",
  "app.logo": "Logo",
  "navigation.landmark": "Main navigation",
  "navigation.heading": "Inventory",
  "navigation.help": "Help",
  "navigation.settings": "Settings",
  "navigation.toggle": "Toggle navigation",
  "avatar.switchOrganisations": "Switch organisations",
  "avatar.profileSettings": "Profile settings",
  "avatar.logout": "Logout",
  "avatar.menu": "User menu",
  "avatar.profile": "User profile",
  "footer.stockConflicts": "{count, plural, one {# stock conflict} other {# stock conflicts}}",
  "footer.workstation": "Workstation name",
  "home.title": "🚀 Application Root Layer",
  "home.description": "Hello World - This is the new root of the Angular MFE.",
  "notFound.title": "Page not found",
  "notFound.description": "The page you're looking for doesn't exist.",
  "notFound.goHome": "Go to home",
  "placeholder.description": "This section is not implemented yet.",
  "common.loadingData": "Loading data",
  "common.divider": "Divider",
  "navigation.dashboard": "Dashboard",
  "navigation.demands": "Demands",
  "navigation.controlCenter": "Control Center",
  "navigation.storageLocations": "Storage Locations",
  "navigation.itemCatalog": "Item Catalog",
  "itemCatalog.allItems": "All items",
  "itemCatalog.createNew": "Create new",
  "itemCatalog.columns.materialCode": "Item code",
  "itemCatalog.columns.materialDescription": "Description",
  "itemCatalog.columns.alternativeCode": "Reference",
  "itemCatalog.columns.manufacturerName": "Manufacturer",
  "itemCatalog.columns.unitIso": "Base unit",
  "itemCatalog.loadError": "Items could not be loaded.",
  "itemCatalog.empty": "No items found.",
  "itemCatalog.resultLimit": "The catalog loading limit has been reached. Refine your search to find more items.",
  "itemCatalog.details.title": "Item details",
  "itemCatalog.details.units": "Units",
  "itemCatalog.details.stockUnit": "Stock unit",
  "itemCatalog.details.gtins": "GTINs",
  "itemCatalog.details.unit": "Unit:",
  "itemCatalog.details.quantity": "Quant:",
  "itemCatalog.details.editItem": "Edit item",
  "moduleHeader.reportedConflicts": "Reported conflicts",
  "moduleHeader.criticalStock": "Critical stock",
  "storageLocations.editStructure": "Edit structure",
  "storageLocations.toggleNode": "Toggle {name}",
  "angular.store.items": "{count, plural, =0 {No items} one {# item} other {# items}}",
  "angular.store.status": "{status, select, ready {Ready} blocked {Blocked} other {Unknown status}}",
  "angular.store.summary": "Quantity: {quantity, number}; value: {amount, number, ::currency/EUR}; date: {date, date, short}",
  "angular.hello.title": "👋 Angular Hello World Route",
  "angular.hello.description": "This page is rendered by the Angular Profile MFE for the internal route",
  "angular.hello.goToStore": "🛒 Go to store through Platform Shell",
  "angular.store.title": "🛒 Angular Store Route",
  "angular.store.description": "The Shell supplied this route. The Angular MFE has switched its local page without modifying browser history itself.",
  "angular.store.returnHome": "🏠 Return to home through Platform Shell",
  "angular.profile.title": "👤 Angular Profile Route",
  "angular.profile.description": "This page is available only in the Angular Profile MFE.",
  "angular.profile.goToStore": "🛒 Open the shared Store page",
  "weblate.roundtrip.items": "{count, plural, =0 {No items} one {# item} other {# items}}",
  "units.piece.short": "pcs.",
  "units.piece.name": "Piece",
  "units.package.short": "PK",
  "units.package.name": "Package"
}
